import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getSettings } from "@/lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [gamificationEnabled, setGamificationEnabled] = useState(true);
  const [loginEnabled, setLoginEnabled] = useState(true);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const s = await getSettings();
      setGamificationEnabled(s.gamification_enabled !== false);
      setLoginEnabled(s.login_enabled !== false);
    } catch {
      // in caso di errore lasciamo il default (acceso)
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ gamificationEnabled, setGamificationEnabled, loginEnabled, setLoginEnabled, loaded, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error("useSettings must be used within SettingsProvider");
  return ctx;
}
